import { HowItWorksUI } from "features";

const HowItWorks = () => {
  return (
    <>
      <HowItWorksUI />
    </>
  );
};
export { HowItWorks };
